export enum OverlayId {
  NONE = "NONE",
  LEADERBOARD_INFO_OVERLAY = "LEADERBOARD_INFO_OVERLAY",
  GAME_RESULT_OVERLAY = "GAME_RESULT_OVERLAY",
  CONTINUE_OVERLAY = "CONTINUE_OVERLAY",
  NEW_GOAL_OVERLAY = "NEW_GOAL_OVERLAY",
  NEW_BOOSTER_OVERLAY = "NEW_BOOSTER_OVERLAY",
  INFINITE_LIVES_OVERLAY = "INFINITE_LIVES_OVERLAY",
  SHOP_OVERLAY = "SHOP_OVERLAY",
  DAILY_CARD_REWARD_OVERLAY = "DAILY_CARD_REWARD_OVERLAY",
  FRIENDS_INFO_OVERLAY = "FRIENDS_INFO_OVERLAY",
  LEVEL_BOX_OPEN_OVERLAY = "LEVEL_BOX_OPEN_OVERLAY",
  WHEEL_OF_FORTUNE_OVERLAY = "WHEEL_OF_FORTUNE_OVERLAY",
  CONVEYOR_RESULT_OVERLAY = "CONVEYOR_RESULT_OVERLAY",
  CONVEYOR_TUTORIAL_OVERLAY = "CONVEYOR_TUTORIAL_OVERLAY",
  HAPPY_FALL_RESULT_OVERLAY = "HAPPY_FALL_RESULT_OVERLAY",
  HAPPY_FALL_WAIT_OVERLAY = "HAPPY_FALL_WAIT_OVERLAY",
  RETURN_GIFT_OVERLAY = "RETURN_GIFT_OVERLAY",
  FIRST_STEPS_OVERLAY = "FIRST_STEPS_OVERLAY",
  FIRST_STEPS_CHEST_OVERLAY = "FIRST_STEPS_CHEST_OVERLAY",
}
